import { service as request } from "./http" 

/**
 * 
 * @param {用户名和密码} data 
 * @returns 
 */
export function login(data) {
    return request({
        url: '/user/login',
        method: 'POST',
        data
    })
}

/**
 * 
 * @returns 根据token获取用户信息
 */
export function getUserInfo() {
    return request({
        url: '/user/info',
        method: 'GET'
    })
}

export function register(data) {
    return request({
        url: '/user/register',
        method: 'POST',
        data
    })
}

/**
 * 
 * @param {修改密码} data 
 * @returns 
 */
export function changePassword(data) {
    return request({
        url: '/user/changePassword',
        method: 'POST',
        data
    })
}

export function getMySource() {
    return request({
        url: '/user/source/all',
        method: 'GET'
    })
}

/**
 * 添加地图源
 * @param {地图源} data 
 * @returns 
 */
export function addMapSource(data) {
    return request({
        url: '/user/source/add',
        method: 'POST',
        data
    })
}


/**
 * 添加地图源
 * @param {地图源} data 
 * @returns 
 */
export function delMapSource(sourceId) {
    return request({
        url: '/user/source/del?sourceId=' + sourceId,
        method: 'GET'
    })
}

/**
 * 
 * @param {激活码} code 
 * @returns 
 */
export function active(code) {
    return request({
        url: '/user/active?activeCode=' + code,
        method: 'GET'
    })
}


export function splice(data) {
    return request({
        url: '/user/splice',
        method: 'POST',
        data
    })
}

/**
 * 获取最新的状态
 * @param {*} data 
 * @returns 
 */
export function ps(data) {
    return request({
        url: '/user/ps',
        method: 'POST',
        data
    })
}

/**
 * 获取图片的边信息
 * @param {uuid} data 
 * @returns 
 */
export function getBoundingBoxInfo(uuid){
    return request({
        url: '/user/bounding?id='+uuid,
        method: 'GET'
    })
}



// WEBPACK FOOTER //
// ./src/util/request.js